import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';
import WarehouseAssortmentListComponent from "./component";

const WarehouseAssortmentListContainer = (props) => {
  const navigate = useNavigate();
  const [assortmentWarehouseMetaDataList, setAssortmentWarehouseMetaDataList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [hasMore, setHasMore] = useState(false);

  const handleWarehouseClick = (reference_id) => {
    navigate(`/home/assortment/assortmentwarehousecreation/${reference_id}`);
  };

  // Initial load
  // useEffect(() => {
  //   fetchWarehouseList("", 0);
  // }, []);

  // Search with debounce
  useEffect(() => {
    const debouncedSearch = debounce(() => {
      setPage(0); // Reset to first page on new search
      fetchWarehouseList(searchTerm, 0);
    }, 500);

    debouncedSearch();

    return () => debouncedSearch.cancel();
  }, [searchTerm]);

  const fetchWarehouseList = (query = "", pageNum = 0) => {
    setLoading(true);
    
    // Build API URL with search parameters
    let apiUrl = `/partner/api/v1/assortment/warehouse/metadata/?page=${pageNum}&size=${size}`;
    
    // Add search query if present
    if (query && query.trim() !== "") {
      apiUrl += `&search=${encodeURIComponent(query.trim())}`;
    }

    props.getDataFromAPI(
      apiUrl,
      "GET",
      undefined,
      (response) => {
        // Handle different response structures
        let warehouseData = [];
        let total = 0;
        
        if (response?.content) {
          // Paginated response
          warehouseData = response.content;
          total = response.totalElements || 0;
          setHasMore(!response.last);
        } else if (Array.isArray(response)) {
          // Array response
          warehouseData = response;
          total = response.length;
          setHasMore(false);
        } else if (response?.content) {
          warehouseData = response.content;
          total = response.totalElements || 0;
          setHasMore(!response.last);
        }

        if (pageNum === 0) {
          setAssortmentWarehouseMetaDataList(warehouseData);
        } else {
          setAssortmentWarehouseMetaDataList(prev => [...prev, ...warehouseData]);
        }
        
        setTotalCount(total);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error("API Error:", err);
        setError(err.message || "Failed to load warehouse data");
        setLoading(false);
        toastr.error("Error", "Failed to load warehouse data");
      }
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    fetchWarehouseList("", 0);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchWarehouseList(searchTerm, nextPage);
  };

  return (
    <WarehouseAssortmentListComponent
      assortmentWarehouseMetaDataList={assortmentWarehouseMetaDataList}
      handleWarehouseClick={handleWarehouseClick}
      loading={loading}
      error={error}
      searchTerm={searchTerm}
      onSearchChange={handleSearchChange}
      onClearSearch={handleClearSearch}
      totalCount={totalCount}
      hasMore={hasMore}
      onLoadMore={handleLoadMore}
    />
  );
};

function mapStateToProps(state) {
  return {
    state
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(WarehouseAssortmentListContainer);